/** Long-press shortcut taps, from boot to the shell (mobile M7). */
import { mailbox } from "@/lib/inbox";
import type { ShortcutId } from "@/platform/shortcuts";

export const shortcutTaps = mailbox<ShortcutId>();
